import React, { useMemo } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "components/Select";
import { getActiveColorStyle } from "utils/colorUtils";
import { getTheme2SearchFilterMultiSelectStyles } from "utils/theme2MultiSelect";

const ReportsFilters = ({
  activeColor = "blue",
  isTheme2 = false,
  showFilters = false,
  searchTerm,
  onSearchChange,
  selectedUser,
  onSelectedUserChange,
  userOptions = [],
  actions = null,
}) => {
  const { t } = useTranslation();
  const activeColorStyle = useMemo(
    () => getActiveColorStyle(activeColor),
    [activeColor]
  );
  const userMultiSelectStyles = useMemo(() => {
    const base = getTheme2SearchFilterMultiSelectStyles(activeColorStyle, isTheme2) || {};
    const baseControl = base.control;
    return {
      ...base,
      control: (provided, state) => {
        const merged = typeof baseControl === "function"
          ? baseControl(provided, state)
          : { ...provided, ...(baseControl || {}) };
        return {
          ...merged,
          minHeight: 38,
          height: 38,
          alignItems: "center",
        };
      },
      valueContainer: (provided, state) => ({
        ...(typeof base.valueContainer === "function"
          ? base.valueContainer(provided, state)
          : provided),
        paddingTop: 0,
        paddingBottom: 0,
        flexWrap: "nowrap",
      }),
      indicatorsContainer: (provided, state) => ({
        ...(typeof base.indicatorsContainer === "function"
          ? base.indicatorsContainer(provided, state)
          : provided),
        height: 38,
      }),
      multiValue: (provided, state) => ({
        ...(typeof base.multiValue === "function"
          ? base.multiValue(provided, state)
          : provided),
        margin: "0 4px 0 0",
      }),
    };
  }, [activeColorStyle, isTheme2]);

  if (!showFilters && !actions) {
    return null;
  }

  return (
    <Form className="search-reports-filters-form">
      <div
        className={
          isTheme2
            ? "search-reports-filters-bar search-reports-filters-row"
            : "search-reports-filters-bar mb-3 mt-2"
        }
      >
        {showFilters ? (
          <>
            <FormGroup className="mb-0 search-reports-filter-field">
              <Label>{t("common.search") || "Search:"}</Label>
              <Input
                type="text"
                className="form-control"
                placeholder={t("common.search") || "Search reports..."}
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </FormGroup>
            <FormGroup className="mb-0 search-reports-filter-field">
              <Label>{t("reports.filterByUser") || "Filter by User:"}</Label>
              <Select
                activeColor={activeColor}
                className="react-select w-100"
                styles={userMultiSelectStyles}
                placeholder={t("reports.filterByUser")}
                name="userFilter"
                isSearchable
                isMulti
                closeMenuOnSelect={false}
                value={selectedUser}
                onChange={(option) => onSelectedUserChange(option)}
                options={userOptions}
                isClearable
              />
            </FormGroup>
          </>
        ) : null}
        {actions ? (
          <FormGroup className="mb-0 search-reports-filter-actions">
            <Label className="search-reports-filter-actions__spacer">&nbsp;</Label>
            <div className="search-reports-filter-actions__btn">{actions}</div>
          </FormGroup>
        ) : null}
      </div>
    </Form>
  );
};

export default ReportsFilters;
